// Action types
export const SET_USER = "SET_USER";

// Create Redux action creators that return an action
export const setUser = (user) => {
    return ({
        type: SET_USER,
        payload: user
    })
};